import { RootState } from "store";

export const getIsIdentified = (state: Partial<RootState>) =>
  state.authentication?.authLevel === "identified";
